var _defs, _rect, _rect2, _path, _polygon, _polyline, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArpaDashboard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    "data-name": "Layer 3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#66748f;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 95.4,
    y: 39.85,
    width: 5.18,
    height: 84.53
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 147.41,
    y: 67.18,
    width: 5.18,
    height: 109.2,
    transform: "translate(271.78 -28.22) rotate(90)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M193.22,54,191.91,52a4,4,0,0,0-5.44-1.25L170.28,60.88l-10-30.66a4.32,4.32,0,0,0-2-2.39,4.22,4.22,0,0,0-2.08-.43l-1.86.16c-.94.5-1.93,1.08-3,1.75a36.9,36.9,0,0,0-3.08,2.24l-36.38,27a4.56,4.56,0,0,0-.94,6.39l.73,1a4.57,4.57,0,0,0,6.39.94L152.89,41l9.53,29.18c.16.34.33.71.54,1.08a16.91,16.91,0,0,0,1.39,2.14,7.7,7.7,0,0,0,3.15.49A7.86,7.86,0,0,0,170,73.3l22-13.83A3.94,3.94,0,0,0,193.22,54Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "136.59 105.75 150.76 105.75 150.76 52.52 149.9 52.52 136.59 62.42 136.59 105.75"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "129.51 105.75 129.51 67.41 128.65 67.41 115.34 77.31 115.34 105.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M165.63,84.87a7.53,7.53,0,0,1-3.15-.48,16,16,0,0,1-1.4-2.15c-.2-.37-.38-.73-.53-1.08l-2.29-7H157v31.59h16.56V80.88l-5.43,3.41A7.34,7.34,0,0,1,165.63,84.87Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M195.27,67.44v38.31H179.76V76.87l4.71-3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArpaDashboard);
export default __webpack_public_path__ + "static/media/arpa_dashboard.83620e434a92b077048338aca811af25.svg";
export { ForwardRef as ReactComponent };